import React from 'react'
import {connect} from 'react-redux'

import config from '../../config.js'

import 'Skelet/src/start.css'; // importing this seems to make it get stuck, so even on other routes and containers the css is still there.
import '../../assets/bountyhub.css'; // importing this seems to make it get stuck, so even on other routes and containers the css is still there.

import {openModal, closeModal} from 'Skelet/src/modules/functions.js'
import ModalAccount from 'Skelet/src/components/ModalAccount.js'
import StartFooter from 'Skelet/src/components/Start_Footer.js'
import CompanyFooter from 'Skelet/src/components/Company_Footer.js'


class StartRoute extends React.Component {

  constructor(props) {
    super(props);

    let modal_open = false;
    let modal_content = "login";
    let reset_token = null;
    if(typeof URLSearchParams === "function") {
      let params = new URLSearchParams(this.props.location.search);
      let param_login = params.get('login');
      let param_reset = params.get('reset');
      let param_verify = params.get('verify'); // this won't be from an e-mail, but might be helpful to manually trigger when bugged.
      if(param_login === "") {
        modal_open = true;
      } else if(param_reset !== null) {
        modal_open = true;
        modal_content = "reset";
        reset_token = params.get('token');
      } else if(param_verify !== null) {
        modal_open = true;
        modal_content = "verify";
      }
    }

    this.state = {modal_open:modal_open, modal_content:modal_content, reset_token:reset_token};
  }

  render() {
    return (
      <div>
        <div className="start">
        <ModalAccount shouldShow={this.state.modal_open} close={() => closeModal(this)} modal_content={this.state.modal_content} reset_token={this.state.reset_token} config={config} header={config.app_id} app_language="EN" />
          <main>
            {/*<Route {...this.props} abc="def" />
            this doesn't pass the props, except for the [this.props], which are passed down from app.js
            cloneElement crashes because of an undefined error, even though it does work with CREATEelement.. */}
            {React.createElement(this.props.component, {
              openModal: (e, modal_content) => openModal(this, e, modal_content),
              config,
              session_token: this.props.session_token
            })}
            {/*this.props.children && React.cloneElement(this.props.children, {
              openModal: this.openModal
            })*/}
          </main>
          <CompanyFooter lang="EN" site="BountyHub.NET" sitemap={{"Start":"start", "Milestones":"milestones"}} />
          <StartFooter lang="EN" />
        </div>
      </div>
    );
  }

}


function mapStateToProps(state, ownProps) {
  let session_token = null;
  if(state.apiData["login"] !== undefined && (state.apiData["login"]["data"]["token"] !== undefined || state.apiData["login"]["data"]["token"] === null)) {
    session_token = state.apiData["login"]["data"]["token"];
  }
  return {
    session_token: session_token,
    // pathname: ownProps.location.pathname
  }
}

export default connect(mapStateToProps, null)(StartRoute)



// WEBPACK FOOTER //
// ./src/containers/route-containers/StartRoute.js